export default "__VITE_ASSET__CacR4kIJ__"